import FieldModel from './FieldModel';
import { PhoneInput } from '../inputs';
import { verifyPhone } from '../../../../juristec-ui/utils/validators/inputTextValidators';

class PhoneField extends FieldModel {
  getDefaultState = () => ({
    value: this.default ?? '',
    error: Boolean(this.required),
    errorMsg: this.required ? 'Informe um telefone válido' : '',
  });

  handleInput = (value, info, handle) => {
    const numbers = value.replace(/[^\d]/g, '');
    const msg = verifyPhone(numbers, this.required, info.name);
    handle({
      [this.kWord]: {
        value: numbers,
        error: msg.length !== 0,
        errorMsg: msg,
      },
    });
  }

  fieldComponent = (tempState, state, handle) => {
    const prepHandle = (value, info) => this.handleInput(value, info, handle);
    return (
      <PhoneInput
        label={this.label}
        state={tempState?.[this.kWord] ?? state[this.kWord] ?? this.getDefaultState()}
        handle={prepHandle}
      />
    );
  }
}

export default PhoneField;
